import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { IActionsCallbacks } from '@src/interfaces'
import type { RootState } from '@src/store'
import { currentUserLang } from '@src/helpers/current-user-lang'
import { EditableForm } from '@src/modules/organisms/editable'
import { setCurrentTemplate } from '@src/slices/configuration.slice'
import { getTemplateByToken } from '@src/services/config.service'
import styles from './styles.module.scss'

const userLang = currentUserLang()

interface IEditTemplate {
  templateHeaderNode: React.ReactNode
  actionsCallback?: IActionsCallbacks
  isSignatureFlow?: boolean
  biometric?: boolean
  documentType?: boolean
  tags?: boolean
  t?: any
  variableVisibility?: () => void
  handleSearch?: () => void
  handleReturn?: () => void
  filterWorkspaceCallback?: (key: string) => boolean
}

const EditTemplate: React.FC<IEditTemplate> = ({
  templateHeaderNode,
  actionsCallback,
  isSignatureFlow,
  biometric,
  documentType,
  tags,
  t, 
  variableVisibility,
  handleSearch,
  filterWorkspaceCallback,
  handleReturn
}) => {
  const dispatch = useDispatch()
  const { currentTemplate } = useSelector(({ configuration }: RootState) => configuration)
  const baseProps = useSelector(({ baseProps }: RootState) => baseProps)
  
  useEffect(() => {
    const { token: templateToken } = currentTemplate

    if (templateToken) {
      getTemplateByToken(baseProps, templateToken, userLang).then(({ data }) => {
        const { template, lang } = data
        const { workspace: token, workspace_title: title } = template
        dispatch(
          setCurrentTemplate({
            template: {
              ...template,
              document_type: template?.document_type?.token,
              workspace: { token, title },
              lang
            }
          })
        )
        actionsCallback?.setCurrentTemplate?.({
          ...template,
          document_type: template?.document_type?.token,
          workspace: { token, title },
          lang
        })
      })
    }
  }, [])

  return (
    <div>
      <h1 className={styles.title}>Modo edición</h1>

      {currentTemplate && currentTemplate.workspace && (
        <EditableForm
          template={currentTemplate}
          isNew={false}
          isSignatureFlow={isSignatureFlow}
          biometric={biometric}
          documentType={documentType}
          tags={tags}
          handleReturn={handleReturn}
          templateHeaderNode={templateHeaderNode}
          actionsCallback={actionsCallback}
          variableVisibility={variableVisibility}
          t={t}
          handleSearch={handleSearch}
          filterWorkspaceCallback={filterWorkspaceCallback}
        />
      )}
    </div>
  )
}

export default EditTemplate
